<template>
    <div class="container-fluid p-5 mt-3">
        <div v-if="ready" class="info-beneficiario mb-4">
            <h4 class="display-4">{{ solicitud?.cliente.nombres }} {{ solicitud?.cliente.apellidos || "" }}</h4>
            <h4 class="display-5">{{ solicitud?.cliente.dni }}</h4>
        </div>

        <div class="archivo-layout">
            <aside class="folder-panel">
                <div class="folder-panel-header">
                    <h5>Carpetas</h5>
                    <span>{{ totalSize }}</span>
                </div>

                <button v-for="folder in folders" :key="folder.key" type="button"
                    :class="['folder-row', { active: activeFolder === folder.key }]" @click="selectFolder(folder.key)">
                    <i :class="folder.system ? 'fas fa-folder' : 'far fa-folder'"></i>
                    <span>{{ folder.label }}</span>
                    <small>{{ folderFileCount(folder.key) }}</small>
                </button>

                <div class="new-folder">
                    <input v-model="newFolderName" class="form-control form-control-sm" type="text"
                        placeholder="Nueva carpeta">
                    <button class="btn btn-primary btn-sm" type="button" @click="createFolder">Crear</button>
                </div>
            </aside>

            <section class="file-panel">
                <div class="file-panel-header">
                    <div>
                        <h5>{{ currentFolder?.label }}</h5>
                        <span>{{ currentFiles.length }} archivo(s)</span>
                    </div>
                    <div class="upload-actions">
                        <label class="btn btn-outline-primary btn-sm mb-0" :for="`folder-file-${activeFolder}`">
                            Subir archivo
                        </label>
                        <input :id="`folder-file-${activeFolder}`" class="d-none" type="file" multiple
                            :accept="currentFolder?.accept || ''" @change="handleFileChange($event, activeFolder)">
                        <button class="btn btn-primary btn-sm" type="button" :disabled="pendingFilesCount === 0"
                            @click="uploadFiles">
                            Guardar
                        </button>
                    </div>
                </div>

                <div v-if="readyArchivos" class="file-grid">
                    <div v-if="currentFiles.length === 0" class="empty-folder">
                        <i class="far fa-folder-open"></i>
                        <p>Esta carpeta no tiene archivos.</p>
                    </div>

                    <div class="file-grid-item" v-for="(file, index) in currentFiles"
                        :key="file.slug || `${file.name}-${index}`">
                        <div v-if="isImage(file)" class="file-preview-frame">
                            <div v-if="isPreviewLoading(file)" class="preview-spinner">
                                <span class="spinner-border spinner-border-sm brand-spinner" role="status"></span>
                            </div>
                            <img v-if="previewSourceReady(file)" v-show="!isPreviewLoading(file)" :src="createImagePreview(file)"
                                class="file-preview-img" alt="Vista previa de imagen" @load="markPreviewLoaded(file)"
                                @error="markPreviewLoaded(file)">
                        </div>
                        <div v-else class="file-icon">
                            <i :class="getFileIcon(file)" class="fas fa-file"></i>
                            <p>{{ file.name }}</p>
                        </div>
                        <p class="file-format">Formato: {{ getFileFormat(file) }}</p>
                        <p v-if="estaGuardado(file, activeFolder)" class="pending-label">Sin Guardar</p>
                        <div class="file-buttons">
                            <button class="btn btn-light btn-sm" @click="deleteFile(file, activeFolder)">
                                <i class="fas fa-trash-alt"></i>
                            </button>
                            <button class="btn btn-light btn-sm" @click="downloadFile(file)">
                                <i class="fas fa-download"></i>
                            </button>
                            <button class="btn btn-light btn-sm" type="button" data-bs-toggle="modal"
                                data-bs-target="#staticBackdrop" @click="mostrarArchivo(file)">
                                <i class="fa-solid fa-eye"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="spinner-border brand-spinner" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
            </section>
        </div>

        <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
            aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog modal-fullscreen">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="staticBackdropLabel">Visualizador de Documentos</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body viewer-body">
                        <embed v-if="base64 !== ''" :src="base64.archivoBase64"
                            :type="generarMimeType(base64.formato)" :width="isPdfFormat(base64.formato) ? '100%' : '70%'"
                            :height="isPdfFormat(base64.formato) ? '100%' : 'auto'" controls="0" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { store } from './store';
import Security from './security';
import Swal from "sweetalert2";

export default {
    data() {
        return {
            uploadedFiles: {},
            showFiles: {},
            customFolders: [],
            activeFolder: "dni",
            newFolderName: "",
            totalSize: "0MB",
            store,
            credito: {},
            solicitud: {},
            ready: false,
            roles: ['Coordinacion', 'Admin', 'Finanzas', 'Asesor', 'Cordinador Sucursal', 'Consultor', 'gestorArchivos', 'oficinaGeneral'],
            Finanzas: false,
            Admin: false,
            Coordinacion: false,
            Asesor: false,
            coordinadorSucursal: false,
            gestorArchivos: false,
            oficinaGeneral: false,
            modoThanos: false,
            Consultor: false,
            readyArchivos: false,
            fileBase64: "",
            base64: "",
            fileUrls: {},
            loadingPreviewUrls: {},
            previewLoaded: {},
            previewLoading: {},
            archivos: [],
        };
    },

    computed: {
        systemFolders() {
            return [
                { key: "dni", label: "DNI cliente", system: true, accept: "image/*" },
                { key: "expediente", label: "Expediente", system: true, accept: "application/pdf" },
            ];
        },
        folders() {
            const systemKeys = new Set(this.systemFolders.map((folder) => folder.key));
            const dynamicKeys = new Set([
                ...Object.keys(this.showFiles),
                ...Object.keys(this.uploadedFiles),
                ...this.customFolders,
            ]);
            const customFolders = Array.from(dynamicKeys)
                .filter((key) => !systemKeys.has(key))
                .sort()
                .map((key) => ({
                    key,
                    label: this.folderLabel(key),
                    system: false,
                    accept: "",
                }));

            return [...this.systemFolders, ...customFolders];
        },
        currentFolder() {
            return this.folders.find((folder) => folder.key === this.activeFolder) || this.folders[0];
        },
        currentFiles() {
            return this.showFiles[this.activeFolder] || [];
        },
        pendingFilesCount() {
            return Object.values(this.uploadedFiles).reduce((total, files) => total + files.length, 0);
        },
    },

    beforeMount() {
        this.initializeFolders();
        this.userRoles = Security.getUserRoles();
        this.roles.forEach(element => {
            if (this.userRoles[0]?.some(role => role.includes(element)) === true) {
                this[element] = true;
            } else if (this.userRoles[0]?.some(role => role.includes('Coordinador Sucursal')) === true) {
                this.coordinadorSucursal = true;
            } else if (this.userRoles[0]?.some(role => role.includes('Modo Thanos')) === true) {
                this.modoThanos = true;
            }
            if (this.userRoles[0]?.some(role => role.includes('Gestor Archivos')) === true) {
                this.gestorArchivos = true;
            }
            if (this.userRoles[0]?.some(role => role.includes('Oficina General')) === true) {
                this.oficinaGeneral = true;
            }
        });

        fetch(
            process.env.VUE_APP_API_URL +
            "/admin/solicitud/" +
            this.$route.params.creditoId,
            Security.requestOptions("", "POST")
        )
            .then((response) => response.json())
            .then((data) => {
                if (data.error) {
                    this.$emit("error", data.message);
                } else {
                    this.solicitud = data.data[0];
                    this.ready = true;
                }
            });

        this.fetchFiles();
    },

    beforeUnmount() {
        Object.values(this.fileUrls).forEach((url) => URL.revokeObjectURL(url));
        this.limpiarURL();
    },

    methods: {
        initializeFolders() {
            this.systemFolders.forEach((folder) => this.ensureFolder(folder.key));
        },
        ensureFolder(folderKey) {
            if (!this.uploadedFiles[folderKey]) {
                this.uploadedFiles[folderKey] = [];
            }
            if (!this.showFiles[folderKey]) {
                this.showFiles[folderKey] = [];
            }
        },
        selectFolder(folderKey) {
            this.ensureFolder(folderKey);
            this.activeFolder = folderKey;
        },
        createFolder() {
            const key = this.normalizeFolderKey(this.newFolderName);
            if (!key) {
                Swal.fire({
                    icon: "error",
                    title: "Nombre de carpeta invalido",
                    confirmButtonText: "Leido",
                });
                return;
            }

            this.ensureFolder(key);
            if (!this.systemFolders.some((folder) => folder.key === key) && !this.customFolders.includes(key)) {
                this.customFolders.push(key);
            }
            this.activeFolder = key;
            this.newFolderName = "";
        },
        normalizeFolderKey(value) {
            return String(value || "")
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase()
                .trim()
                .replace(/[^a-z0-9]+/g, "-")
                .replace(/^-+|-+$/g, "");
        },
        folderLabel(key) {
            const systemFolder = this.systemFolders.find((folder) => folder.key === key);
            if (systemFolder) {
                return systemFolder.label;
            }

            return String(key || "")
                .split("-")
                .filter(Boolean)
                .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
                .join(" ");
        },
        folderFileCount(folderKey) {
            return (this.showFiles[folderKey] || []).length;
        },
        isSystemImageFolder(folderKey) {
            return folderKey === "dni";
        },
        handleFileChange(event, folderKey) {
            this.ensureFolder(folderKey);
            const files = Array.from(event.target.files || []);

            if (files.length === 0) {
                return;
            }

            if (this.isSystemImageFolder(folderKey)) {
                const invalidFile = files.find((file) => !file.type.startsWith('image/'));
                if (invalidFile) {
                    Swal.fire({
                        icon: "error",
                        title: "Formato no permitido",
                        text: "Esta carpeta solo permite imagenes JPG o PNG.",
                        confirmButtonText: "Leido",
                    });
                    event.target.value = "";
                    return;
                }
            }

            if (folderKey === "expediente") {
                const invalidFile = files.find((file) => file.type !== "application/pdf");
                if (invalidFile) {
                    Swal.fire({
                        icon: "error",
                        title: "Formato no permitido",
                        text: "La carpeta Expediente solo permite archivos PDF.",
                        confirmButtonText: "Leido",
                    });
                    event.target.value = "";
                    return;
                }
            }

            files.forEach((file) => {
                file.folderKey = folderKey;
                this.uploadedFiles[folderKey].push(file);
                this.showFiles[folderKey].push(file);
            });
            event.target.value = "";
            this.recalculateTotalSize();
        },
        isImage(file) {
            return file.type?.startsWith('image/');
        },
        createImagePreview(file) {
            if (file.saved) {
                if (!this.fileUrls[file.slug]) {
                    this.loadProtectedFileUrl(file);
                }
                return this.fileUrls[file.slug] || "";
            }

            if (!file.previewUrl) {
                file.previewUrl = URL.createObjectURL(file);
            }
            return file.previewUrl;
        },
        filePreviewKey(file) {
            return file.slug || file.previewUrl || `${file.folderKey || this.activeFolder}-${file.name}`;
        },
        isPreviewLoading(file) {
            if (!this.isImage(file)) {
                return false;
            }

            if (file.saved && !this.fileUrls[file.slug]) {
                this.loadProtectedFileUrl(file);
                return true;
            }
            if (!file.saved && !file.previewUrl) {
                file.previewUrl = URL.createObjectURL(file);
            }

            return this.previewLoaded[this.filePreviewKey(file)] !== true;
        },
        previewSourceReady(file) {
            if (file.saved) {
                return Boolean(this.fileUrls[file.slug]);
            }

            return Boolean(file.previewUrl);
        },
        markPreviewLoaded(file) {
            const key = this.filePreviewKey(file);
            this.previewLoaded = { ...this.previewLoaded, [key]: true };
            this.previewLoading = { ...this.previewLoading, [key]: false };
        },
        esFormatoValidoParaEmbed(formato) {
            formato = String(formato || "").toLowerCase();
            return ['.pdf', '.jpg', '.jpeg', '.png', '.gif', 'pdf', 'jpg', 'jpeg', 'png', 'gif'].includes(formato);
        },
        isPdfFormat(formato) {
            return String(formato || "").toLowerCase().replace(".", "") === "pdf";
        },
        getFileIcon(file) {
            const fileType = file.type || "";
            if (fileType.includes('pdf')) return 'fas fa-file-pdf';
            if (fileType.includes('word')) return 'fas fa-file-word';
            if (fileType.includes('excel') || fileType.includes('spreadsheet')) return 'fas fa-file-excel';
            if (fileType.includes('audio')) return 'fas fa-file-audio';
            return 'fas fa-file-alt';
        },
        getFileFormat(file) {
            const fileType = file.type || "";
            const format = fileType.split('/')[1];
            return format ? format.toUpperCase() : 'Desconocido';
        },
        deleteFile(file, folderKey) {
            if (this.estaGuardado(file, folderKey)) {
                this.removeLocalFile(file, folderKey);
                return;
            }

            if (this.Admin || this.gestorArchivos) {
                const payload = { slug: file.name };
                Swal.fire({
                    title: 'Esta seguro que desea eliminar?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Confirmar!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        fetch(process.env.VUE_APP_API_URL + `/admin/solicitud/archivo-delete`, Security.requestOptions(payload))
                            .then((response) => response.json())
                            .then((response) => {
                                if (response.error) {
                                    this.$emit('error', response.message);
                                } else {
                                    this.uploadedFilesEnCero();
                                    this.readyArchivos = false;
                                    this.fetchFiles();
                                }
                            })
                            .catch(error => {
                                this.$emit('error', error);
                            });
                    }
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Solicita eliminar a tu administrador!",
                    showConfirmButton: false,
                    timer: 2000,
                });
            }
        },
        removeLocalFile(file, folderKey) {
            if (file.previewUrl) {
                URL.revokeObjectURL(file.previewUrl);
            }
            this.uploadedFiles[folderKey] = (this.uploadedFiles[folderKey] || []).filter((item) => item !== file);
            this.showFiles[folderKey] = (this.showFiles[folderKey] || []).filter((item) => item !== file);
            this.recalculateTotalSize();
        },
        limpiarURL() {
            if (this.base64 && this.base64.archivoBase64) {
                URL.revokeObjectURL(this.base64.archivoBase64);
                this.base64 = '';
            }
        },
        async mostrarArchivo(file) {
            this.limpiarURL();
            const archivoEncontrado = this.archivos.find(archivo => archivo.slug === file.name || archivo.slug === file.slug);

            if (archivoEncontrado) {
                if (this.esFormatoValidoParaEmbed(archivoEncontrado.formato)) {
                    const url = await Security.authenticatedBlobUrl(archivoEncontrado.url || `/admin/solicitud/archivo/${encodeURIComponent(file.slug || file.name)}`);
                    this.base64 = { ...archivoEncontrado, archivoBase64: url };
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Formato de archivo no valido para previsualizacion!",
                        showConfirmButton: false,
                        timer: 2000,
                    });
                }
            } else if (!file.saved) {
                this.base64 = {
                    formato: `.${(file.name.split('.').pop() || '').toLowerCase()}`,
                    archivoBase64: URL.createObjectURL(file),
                };
            }
        },
        async downloadFile(file) {
            let url;
            if (file.saved) {
                url = await Security.authenticatedBlobUrl(file.url || `/admin/solicitud/archivo/${encodeURIComponent(file.slug)}`);
            } else {
                url = URL.createObjectURL(file);
            }
            const a = document.createElement('a');
            a.href = url;
            a.download = file.name;
            a.click();
            setTimeout(() => URL.revokeObjectURL(url), 1000);
        },
        async uploadFiles() {
            const formData = new FormData();

            for (const [folderKey, files] of Object.entries(this.uploadedFiles)) {
                files.forEach((file) => {
                    formData.append(folderKey, file);
                });
            }

            formData.append('idSolicitud', this.solicitud.id);
            formData.append('idUsuario', this.store.user.id);

            try {
                const response = await fetch(process.env.VUE_APP_API_URL + `/admin/solicitud/insertImg`, {
                    method: 'POST',
                    body: formData,
                    headers: {
                        Authorization: `Bearer ${store.token}`,
                    },
                });

                const data = await response.json();
                if (!response.ok || data.error) {
                    throw new Error(data.message || 'Error en la subida de archivos');
                }

                Swal.fire({
                    icon: "success",
                    title: "Archivo Guardado Exitosamente!",
                    showConfirmButton: false,
                    timer: 1500,
                });
                this.uploadedFilesEnCero();
                this.fetchFiles();
            } catch (error) {
                Swal.fire({
                    icon: "error",
                    title: "No se pudo guardar el archivo",
                    text: error.message || "Hubo un error al subir los archivos.",
                    confirmButtonText: "Leido",
                });
            }
        },
        async fetchFiles() {
            try {
                const response = await fetch(process.env.VUE_APP_API_URL + '/admin/solicitud/getArchivos/' + this.$route.params.creditoId, Security.requestOptions({}));
                if (!response.ok) {
                    throw new Error('Error al obtener archivos');
                }
                const formData = await response.json();
                this.parseFormData(formData);
            } catch (error) {
                console.error('Error:', error);
            }

            this.readyArchivos = true;
        },
        parseFormData(formData) {
            this.uploadedFiles = {};
            this.showFiles = {};
            this.customFolders = [];
            this.initializeFolders();
            this.archivos = formData.data.archivo || [];

            for (let i = 0; i < this.archivos.length; i++) {
                const folderKey = this.archivos[i].tipoArchivo;
                if (folderKey === "beneficiario") {
                    continue;
                }
                this.ensureFolder(folderKey);
                if (!this.systemFolders.some((folder) => folder.key === folderKey) && !this.customFolders.includes(folderKey)) {
                    this.customFolders.push(folderKey);
                }

                const mimeType = this.generarMimeType(this.archivos[i].formato);
                const file = {
                    id: this.archivos[i].id,
                    name: this.archivos[i].slug,
                    slug: this.archivos[i].slug,
                    type: mimeType,
                    size: this.archivos[i].size || 0,
                    url: this.archivos[i].url,
                    thumbnailUrl: this.archivos[i].thumbnailUrl,
                    saved: true,
                    folderKey,
                };

                this.showFiles[folderKey].push(file);
            }

            this.recalculateTotalSize();
            if (!this.showFiles[this.activeFolder]) {
                this.activeFolder = "dni";
            }
        },
        recalculateTotalSize() {
            const totalBytes = Object.values(this.showFiles)
                .flat()
                .reduce((total, file) => total + (file.size || 0), 0);
            const totalSizeInMB = totalBytes / (1024 * 1024);

            if (totalSizeInMB < 1024) {
                this.totalSize = totalSizeInMB.toFixed(2) + "MB";
            } else {
                this.totalSize = (totalSizeInMB / 1024).toFixed(2) + "GB";
            }
        },
        async loadProtectedFileUrl(file) {
            if (this.loadingPreviewUrls[file.slug]) {
                return;
            }

            this.loadingPreviewUrls = { ...this.loadingPreviewUrls, [file.slug]: true };
            try {
                const url = await this.getProtectedFileUrl(file);
                this.fileUrls = { ...this.fileUrls, [file.slug]: url };
            } catch (error) {
                this.markPreviewLoaded(file);
                console.error(error);
            } finally {
                this.loadingPreviewUrls = { ...this.loadingPreviewUrls, [file.slug]: false };
            }
        },
        async getProtectedFileUrl(file) {
            if (this.fileUrls[file.slug]) {
                return this.fileUrls[file.slug];
            }

            return Security.authenticatedBlobUrl(file.thumbnailUrl || file.url || `/admin/solicitud/archivo/${encodeURIComponent(file.slug)}`);
        },
        generarMimeType(formato) {
            formato = String(formato || "").replace('.', '').toLowerCase();
            if (['pdf', 'zip', 'json', 'xml'].includes(formato)) {
                return `application/${formato}`;
            }
            if (['jpg', 'jpeg', 'png', 'gif'].includes(formato)) {
                return `image/${formato}`;
            }
            if (formato === 'txt') {
                return "text/plain";
            }
            if (formato === 'doc') {
                return "application/msword";
            }
            if (formato === 'docx') {
                return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
            }
            if (formato === 'xls') {
                return "application/vnd.ms-excel";
            }
            if (formato === 'xlsx') {
                return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            }
            return `application/${formato}`;
        },
        estaGuardado(file, folderKey) {
            return (this.uploadedFiles[folderKey] || []).includes(file);
        },
        uploadedFilesEnCero() {
            Object.values(this.showFiles).flat().forEach((file) => {
                if (file.previewUrl) {
                    URL.revokeObjectURL(file.previewUrl);
                }
            });
            this.uploadedFiles = {};
            this.showFiles = {};
            this.customFolders = [];
            this.initializeFolders();
        }
    },
};
</script>

<style scoped>
.info-beneficiario {
    border-radius: 5px;
}

.archivo-layout {
    display: grid;
    grid-template-columns: 280px minmax(0, 1fr);
    gap: 18px;
    align-items: start;
}

.folder-panel,
.file-panel {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    background: #fff;
}

.folder-panel {
    padding: 12px;
}

.folder-panel-header,
.file-panel-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
}

.folder-panel-header h5,
.file-panel-header h5 {
    margin: 0;
}

.folder-panel-header span,
.file-panel-header span {
    color: #6b7280;
    font-size: 12px;
}

.folder-row {
    width: 100%;
    min-height: 42px;
    display: grid;
    grid-template-columns: 22px 1fr auto;
    align-items: center;
    gap: 8px;
    border: 0;
    border-radius: 6px;
    background: transparent;
    color: #1f2937;
    padding: 8px;
    text-align: left;
}

.folder-row i {
    color: #192230;
}

.folder-row:hover,
.folder-row.active {
    background: #eef0f2;
    color: #192230;
}

.folder-row span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.folder-row small {
    color: #4b5563;
}

.new-folder {
    display: flex;
    gap: 8px;
    margin-top: 14px;
}

.file-panel {
    min-height: 520px;
    padding: 16px;
}

.upload-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.file-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
}

.empty-folder {
    width: 100%;
    min-height: 260px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #6b7280;
}

.empty-folder i {
    font-size: 52px;
    margin-bottom: 10px;
}

.file-grid-item {
    width: 160px;
    text-align: center;
    border: 1px solid #ddd;
    padding: 10px;
    border-radius: 5px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.08);
}

.file-preview-img {
    width: 100%;
    height: 80px;
    object-fit: cover;
    border-radius: 5px;
}

.file-preview-frame {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    background: #f3f4f6;
}

.preview-spinner {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.file-icon {
    font-size: 50px;
    color: #192230;
    margin-bottom: 5px;
}

.file-grid-item p {
    font-size: 12px;
    margin: 0;
    padding: 5px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
}

.file-format {
    font-size: 10px;
    color: gray;
    margin-top: 5px;
}

.file-buttons {
    display: flex;
    justify-content: space-around;
    margin-top: 5px;
}

.file-buttons button {
    width: 36px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.08);
}

.file-buttons i {
    font-size: 14px;
}

.btn-primary {
    background-color: #192230;
    border-color: #192230;
    color: white;
}

.btn-primary:hover,
.btn-primary:focus {
    background-color: #111722;
    border-color: #111722;
    color: white;
}

.btn-outline-primary {
    border-color: #192230;
    color: #192230;
}

.btn-outline-primary:hover,
.btn-outline-primary:focus {
    background-color: #192230;
    border-color: #192230;
    color: white;
}

.pending-label {
    color: #192230;
}

.brand-spinner {
    color: #192230;
}

.viewer-body {
    text-align: center;
}

@media (max-width: 991px) {
    .archivo-layout {
        grid-template-columns: 1fr;
    }
}
</style>
